import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
  selector: 'vui-mobile-icon',
  templateUrl: './mobile-icon.component.html'
})
export class MobileIconComponent extends AbstractIcon {
  constructor() {
      super();
      this.height = 24;
      this.width = 16;
  }
}
